import { createFileRoute } from "@tanstack/react-router";

import Layout from "theme/ui/Layout";


export const Route = createFileRoute("/_private/_home")({
	component: () => <Layout.Light />
});